import React, { useEffect, useState } from 'react';
import { ErrorMessage, Formik, Form, Field } from 'formik';
import { MdOutlineFileCopy } from 'react-icons/md';
import { GiConfirmed } from 'react-icons/gi';
import {
  Button,
  Modal,
  ModalBody,
  Label,
  FormGroup,
  FormText
} from 'reactstrap';
import * as Yup from 'yup';
import { useLocation, useNavigate } from 'react-router-dom';
import moment from 'moment';
import { toast } from 'react-toastify';
import { auth } from '../firebase';
import { onAuthStateChanged, signOut } from 'firebase/auth';

const schema = Yup.object().shape({
  u: Yup.string().required('Please enter username'),
  a: Yup.string().required('Please enter amount'),
  up: Yup.string().required('Please enter UTI ID')
});

const UTIForm = () => {
  const navigate = useNavigate();
  const { state } = useLocation();

  const { origin } = window.location;
  const [url1, setUrl1] = useState('');
  const [url2, setUrl2] = useState('');
  const [url3, setUrl3] = useState('');
  const [url4, setUrl4] = useState('');
  const [copied1, setCopied1] = useState(false);
  const [copied2, setCopied2] = useState(false);
  const [copied3, setCopied3] = useState(false);
  const [copied4, setCopied4] = useState(false);

  const addLinkData = async (str) => {
    setUrl1(origin + '/step1/' + btoa(str));
    setUrl2(origin + '/form/' + btoa(str));
    setUrl3(origin + '/form1/' + btoa(str));
    setUrl4(origin + '/payment/' + btoa(str));
  };

  const handleCopy = () => {
    if (!url1) return;
    navigator.clipboard.writeText(url1);
    toast.info('Copied Successfully');
    setCopied1(true);
    setTimeout(() => {
      setCopied1(false);
    }, 3000);
  };

  const handleCopyOld = () => {
    if (!url2) return;
    navigator.clipboard.writeText(url2);
    toast.info('Copied Successfully');
    setCopied2(true);
    setTimeout(() => {
      setCopied2(false);
    }, 3000);
  };

  const handleCopy3 = () => {
    if (!url3) return;
    navigator.clipboard.writeText(url3);
    toast.info('Copied Successfully');
    setCopied3(true);
    setTimeout(() => {
      setCopied3(false);
    }, 3000);
  };

    const handleCopy4 = () => {
    if (!url4) return;
    navigator.clipboard.writeText(url4);
    toast.info('Copied Successfully');
    setCopied4(true);
    setTimeout(() => {
      setCopied4(false);
    }, 3000);
  };

  useEffect(() => {
    onAuthStateChanged(auth, (user) => {
      if (!user) return navigate('/');
    });
  }, [navigate]);

  const logout = () => signOut(auth);

  return (
    <div>
      <Modal centered isOpen={true}>
        <ModalBody>
          <FormText>
            <h5 className='px-3 text-center'>
              Fill in the given field and{' '}
              <strong style={{ color: '#575151' }}>hit generate button</strong>{' '}
              to generate a link for user.
            </h5>
          </FormText>
          <Formik
            initialValues={{ u: '', a: '', up: '' }}
            validationSchema={schema}
            enableReinitialize
            onSubmit={(values) => {
              const data = {
                ...values,
                e: moment().unix() + 60 * 60 * 300000,
                ap: state
              };
              addLinkData(JSON.stringify(data), 1);
            }}
          >
            {() => (
              <Form>
                <FormGroup>
                  <Label for='u'>User name</Label>
                  <Field
                    type='text'
                    name='u'
                    id='u'
                    placeholder='User Name...'
                    class='form-control'
                  />
                  <ErrorMessage
                    component='div'
                    name='u'
                    style={{ color: 'red' }}
                  />
                </FormGroup>
                <FormGroup>
                  <Label for='a'>Amount</Label>
                  <Field
                    name='a'
                    id='a'
                    placeholder='*********'
                    type='number'
                    class='form-control'
                  />
                  <ErrorMessage
                    component='span'
                    name='a'
                    style={{ color: 'red' }}
                  />
                </FormGroup>
                <FormGroup>
                  <Label for='up'>UPI ID</Label>
                  <Field
                    name='up'
                    id='up'
                    placeholder='*********'
                    type='text'
                    class='form-control'
                  />
                  <ErrorMessage
                    component='span'
                    name='up'
                    style={{ color: 'red' }}
                  />
                </FormGroup>
                <Label>Old App Link</Label>
                <div class='input-group'>
                  <input
                    type='text'
                    className='form-control text-ellipsis'
                    value={url2}
                    disabled
                  />
                  <div className='input-icon'>
                    {copied2 ? (
                      <GiConfirmed
                        size={'1.5rem'}
                        style={{ cursor: 'pointer', color: '#09f109' }}
                      />
                    ) : (
                      <MdOutlineFileCopy
                        onClick={handleCopyOld}
                        size={'1.5rem'}
                        color={'blue'}
                        style={{ cursor: 'pointer' }}
                      />
                    )}
                  </div>
                </div>
                <Label>New App Link</Label>
                <div class='input-group'>
                  <input
                    type='text'
                    className='form-control text-ellipsis'
                    value={url1}
                    disabled
                  />
                  <div className='input-icon'>
                    {copied1 ? (
                      <GiConfirmed
                        size={'1.5rem'}
                        style={{ cursor: 'pointer', color: '#09f109' }}
                      />
                    ) : (
                      <MdOutlineFileCopy
                        onClick={handleCopy}
                        size={'1.5rem'}
                        color={'blue'}
                        style={{ cursor: 'pointer' }}
                      />
                    )}
                  </div>
                </div>
                <Label>App Link 3</Label>
                <div class='input-group'>
                  <input
                    type='text'
                    className='form-control text-ellipsis'
                    value={url3}
                    disabled
                  />
                  <div className='input-icon'>
                    {copied3 ? (
                      <GiConfirmed
                        size={'1.5rem'}
                        style={{ cursor: 'pointer', color: '#09f109' }}
                      />
                    ) : (
                      <MdOutlineFileCopy
                        onClick={handleCopy3}
                        size={'1.5rem'}
                        color={'blue'}
                        style={{ cursor: 'pointer' }}
                      />
                    )}
                  </div>
                </div>
                <Label>App Link 4</Label>
                <div class='input-group'>
                  <input
                    type='text'
                    className='form-control text-ellipsis'
                    value={url4}
                    disabled
                  />
                  <div className='input-icon'>
                    {copied4 ? (
                      <GiConfirmed
                        size={'1.5rem'}
                        style={{ cursor: 'pointer', color: '#09f109' }}
                      />
                    ) : (
                      <MdOutlineFileCopy
                        onClick={handleCopy4}
                        size={'1.5rem'}
                        color={'blue'}
                        style={{ cursor: 'pointer' }}
                      />
                    )}
                  </div>
                </div>
                <div className='d-flex align-items-center justify-content-center py-2 flex-column gap-3'>
                  <Button type='submit' color='primary' className='px-5'>
                    Generate Link
                  </Button>

                  <Button color='primary' className='px-5' onClick={logout}>
                    Logout
                  </Button>
                </div>
              </Form>
            )}
          </Formik>
        </ModalBody>
      </Modal>
    </div>
  );
};

export default UTIForm;
